import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useEffect, type ReactNode } from 'react';

/**
 * The top of every page: the headline (a short sentence ending in a full stop), a lead
 * line, and the page's buttons on the right (under the headline on phones).
 */
export function PageHeader({ title, lead, actions, documentTitle }: { title: string; lead?: ReactNode; actions?: ReactNode; documentTitle?: string }) {
  useEffect(() => {
    document.title = `${documentTitle ?? title.replace(/[.?]$/, '')} · Pulsepoint`;
  }, [title, documentTitle]);
  return (
    <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} sx={{ alignItems: { md: 'flex-end' }, justifyContent: 'space-between', mb: { xs: 3, md: 4 } }}>
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h1">{title}</Typography>
        {lead && (
          <Typography variant="subtitle1" component="div" sx={{ mt: 1 }}>
            {lead}
          </Typography>
        )}
      </Box>
      {actions && (
        <Stack direction="row" spacing={1.5} sx={{ flexWrap: 'wrap', rowGap: 1.5, flexShrink: 0 }}>
          {actions}
        </Stack>
      )}
    </Stack>
  );
}
